export const LOCALES = ['en', 'ja', 'zh-Hant'] as const

export type Locale = (typeof LOCALES)[number]

export const DEFAULT_LOCALE: Locale = 'en'

export const LOCALE_STORAGE_KEY = 'fsjudo-locale'

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'en' || value === 'ja' || value === 'zh-Hant'
}

/** Map browser language tags to supported locales. */
export function detectLocale(languages: readonly string[] = navigator.languages): Locale {
  for (const raw of languages) {
    const tag = raw.toLowerCase()
    if (tag.startsWith('ja')) return 'ja'
    if (
      tag === 'zh-hant' ||
      tag.startsWith('zh-hant') ||
      tag.startsWith('zh-tw') ||
      tag.startsWith('zh-hk') ||
      tag.startsWith('zh-mo')
    ) {
      return 'zh-Hant'
    }
    if (tag === 'zh' || tag.startsWith('zh-')) {
      // Default Chinese browsers without region to Traditional for this product audience.
      if (tag.startsWith('zh-cn') || tag.startsWith('zh-sg') || tag.startsWith('zh-hans')) {
        continue
      }
      return 'zh-Hant'
    }
    if (tag.startsWith('en')) return 'en'
  }
  return DEFAULT_LOCALE
}

export function htmlLang(locale: Locale): string {
  switch (locale) {
    case 'ja':
      return 'ja'
    case 'zh-Hant':
      return 'zh-Hant'
    default:
      return 'en'
  }
}
